import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from 'hooks/redux'
import InvestmentsHome from 'assets/skeletons/InvestmentsHome'
import { useDispatch } from 'react-redux'
import { getInvestmentParams, getTutorialCompletion } from 'store/investments/thunks'

interface InvestmentsGuardProps {
  children: React.ReactElement
  redirectPath?: string
}

const InvestmentsGuard: React.FC<InvestmentsGuardProps> = ({ children, redirectPath = '/content/wallet' }) => {
  const dispatch = useDispatch()
  const {
    tutorialCompleted,
    authorization,
    isTutorialLoading,
    isParamsLoading
  } = useAppSelector(state => state.investments)

  useEffect(() => {
    dispatch(getTutorialCompletion())
    dispatch(getInvestmentParams())
  }, [dispatch])

  const notInitialized = tutorialCompleted === null || authorization === null

  if (isTutorialLoading || isParamsLoading || notInitialized) {
    return <InvestmentsHome />
  }

  const canAccess = tutorialCompleted && authorization

  if (!canAccess) {
    return <Navigate to={redirectPath} replace />
  }
  return children
}

export default InvestmentsGuard

InvestmentsGuard.defaultProps = {
  redirectPath: '/content/wallet'
}
